var r = (t, i, o) => new Promise((g, a) => {
  var u = (n) => {
    try {
      e(o.next(n));
    } catch (s) {
      a(s);
    }
  }, y = (n) => {
    try {
      e(o.throw(n));
    } catch (s) {
      a(s);
    }
  }, e = (n) => n.done ? g(n.value) : Promise.resolve(n.value).then(u, y);
  e((o = o.apply(t, i)).next());
});
import { selfAxios as m } from "@oppein/op-utils";
function f(t) {
  return r(this, null, function* () {
    const { data: i } = yield m.get(
      "/ucenterapi/anonymous/internal/region/getRegionListByPidToAnonymous",
      { params: t }
    );
    return i;
  });
}
export {
  f as getRegionListByPidToAnonymous
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/ucenterapi/anonymous/internal/region/getRegionListByPidToAnonymous/get.js
// module id = 1833
// module chunks = 67